import { editDeviceCalibrateResultRequest, getDeviceCalibrateResultRequest } from "@/service/parameterConfiguration";
import { Button, Col, Divider, Form, Input, InputNumber, Row, Tooltip, message } from "antd";
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";

interface iProps {
    id: number | string,
    sn: number | string,
    refreshTrigger?: number,
    onRefreshAll?: () => void
}

const RadarYzyForm = (props: iProps) => {

    const { id, sn, refreshTrigger, onRefreshAll } = props

    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [hasSearch, setHasSearch] = useState(false);


    const updateForm = async () => {
        let _formValue = {};
        try {
            setIsLoading(true);
            const res = await getDeviceCalibrateResultRequest({ id, sn });
            const data = res.data?.data || {};

            const parseNumber = (v: any) => (v === null || v === undefined || v === '' ? undefined : Number(v));

            _formValue = {
                version: data.version,
                success: parseNumber(data.success),
                xOffset: parseNumber(data.xOffset),
                yOffset: parseNumber(data.yOffset),
                zOffset: parseNumber(data.zOffset),
                wheelbase: parseNumber(data.wheelbase),
            };
            setHasSearch(true);
        } catch (err) {
            console.error("err", err);
        } finally {
            setIsLoading(false);
            form.setFieldsValue(_formValue);
        }

    }
    useEffect(() => {
        updateForm();
    }, [id, sn, refreshTrigger]);


    const submitForm = async () => {
        try {
            setIsLoading(true);
            const values = await form.validateFields();
            const params = {
                id,
                ...values
            }
            const res = await editDeviceCalibrateResultRequest(params, sn);
            
            if (res.data.code === 0) {
                message.success('下发雷达标定结果成功');
                // 提交成功后通知所有表单刷新
                onRefreshAll?.();
            } else {
                message.error('下发雷达标定结果失败');
            }
        } catch (error) {
            console.error("submit failed:", error);
            message.error('下发雷达标定结果失败');
        } finally {
            setIsLoading(false);
        }
    }

    return <div>
        <Divider>雷达标定结果</Divider>
        <Form form={form} labelAlign="left" labelCol={{ span: 6, style: { whiteSpace: 'normal', overflowWrap: 'break-word' } }} wrapperCol={{ span: 14 }}>
            <Form.Item label="参数版本号" name="version" style={{ marginBottom: '20px' }}>
                <Input disabled={true} />
            </Form.Item>
            <Form.Item 
                label={
                    <span>
                        标定状态
                        <Tooltip title="园之云雷达和相机共用标定状态">
                            <QuestionCircleOutlined style={{ marginLeft: 4, color: '#999' }} />
                        </Tooltip>
                    </span>
                } 
                name="success" 
                style={{ marginBottom: '20px' }}
            >
                <InputNumber style={{ width: '100%' }} disabled={true} />
            </Form.Item>
            <Form.Item label="后轴到雷达距离(单位:米)" name="xOffset" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="雷达中心偏离(左正右负)(单位:米)" name="yOffset" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="雷达中心离地高度(单位:米)" name="zOffset" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="车辆轴距(单位:米)" name="wheelbase" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} disabled={true} />
            </Form.Item>
            <div style={{ textAlign: 'right' }}>
                <Button
                    type="primary"
                    disabled={!hasSearch}
                    loading={isLoading}
                    onClick={submitForm}
                >
                    下发雷达标定结果
                </Button>
            </div>
        </Form>
    </div>
};

export default RadarYzyForm;